import { classNameMerger } from '@breetometer/utils';

export const SettingsWrapper = ({ children, isSub }: { children: React.ReactNode; isSub?: boolean }) => (
	<div className='bodycontent-wrapper'>
		<div className={classNameMerger('bg-primary-500 border-dark-navy child', isSub && 'sub-body')}>{children}</div>
	</div>
);
